export const DFV_PLAY_VIEWED = 'DFV_PLAY_VIEWED';

export const dfvPlayViewedAction = (atBatIndex) => (dispatch) => {
    dispatch({
        type: DFV_PLAY_VIEWED,
        index: atBatIndex
    });
};

export default dfvPlayViewedAction;
